import { useEffect, useState } from "react";
import { getFooterModel } from "../../../../api/footerApi";
import { FooterData } from "../../../../api/footerApi.types";

export const useFooterData = (currentPageId: number) => {
  const [footerData, setFooterData] = useState<FooterData>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);

      const result = await getFooterModel(currentPageId);

      setFooterData(result);
      setLoading(false);
    };

    fetchContent();
  }, [currentPageId]);

  return { footerData, loading };
};
